import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {getLogoUrl} from '../FlexSuiteLogos/logo-assets'

export type TestimonialLogo = string | Asset

export function resolveTestimonialLogo(logo?: TestimonialLogo) {
  if (typeof logo === 'string') {
    const url = getLogoUrl(logo)

    return url ? {url, alt: logo} : undefined
  }

  const url = logo?.fields.file?.url

  return url ? {url, alt: logo.fields.description ?? ''} : undefined
}
